// extracted by mini-css-extract-plugin
module.exports = {"mCard":"hg","image":"ig","imageNoBackground":"jg"};